<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'

    import { staticHashed } from 'hydria/static_hashed'

    import Group from './Group.svelte'
    import Item from './Item.svelte'
    import { items } from './items'
</script>

<aside id="leftbar">
    <nav>
        <img src={staticHashed('static/img/wdom-2-logo-text-white.svg')} class="img-responsive logo-client" alt="WebDomaine" />
        {#each items as item}
            {#if item.type == 'group'}
                <Group {item} />
            {:else}
                <Item {item} />
            {/if}
        {/each}
    </nav>
</aside>
